import React from "react";

export function PropertyCardTitle({ title }: { title: string }) {
    return <>{title}</>;
}
